var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-nm-audio"},[_c('audio',{ref:"audio",staticClass:"c-nm-audio__audio",attrs:{"src":_vm.audio.url,"controls":""},on:{"play":function($event){return _vm.$emit('ply', _vm.audio.id)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }